module.exports = __webpack_public_path__ + "1ef370ed3b73bc9f22140cda027c78be.png";